import "babel-polyfill"; // 解决Ie9
import Vue from "vue";
import App from "./App.vue";
import globalData from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import "./element";

import * as filters from "./filtres/index"; // 全局过滤器
import "./role"; // 权限

// import "./mock"; // 模拟数据

import { IMG_BASE_URL } from "./config/app";

import "./assets/icons/iconfont";
import IconSvg from "./components/common/IconSvg.vue"; // svg组件

import axios from 'axios';
Vue.prototype.$http = axios;
Vue.prototype.βgetApp = App;
Vue.prototype.βimgBaseUrl = IMG_BASE_URL;

// 注册全局组件（register global）
Vue.component("icon-svg", IconSvg);
Vue.prototype.βwaterIndicatorsMap = {
    detect_time: '检测日期',
    air: '气温(℃)',
    ntu: '浊度(NTU)',
    cod: 'COD(mg/L)',
    bod: 'BOD(mg/L)',
    anyan: '氨氮(mg/L)',
    zongyan: '总氮(mg/L)',
    zonglin: '总磷(mg/L)',
    oxygen: '溶解氧(mg/L)',
    ph: 'pH',
    oxidation: '氧化还原电位(mV)',
    transparent: '透明度(cm)',
    remark: '备注'
}

// 注册全局实用程序过滤器（register global utility filters）.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
